import { Company } from '../../shared/types/company';
import { Profile } from '../../shared/types/profile';

export type ResponseProfile = Omit<
  Profile,
  'createdByFullName' | 'updatedByFullName' | 'createdById' | 'updatedById'
> & {
  email: string;
  isActive: boolean;
};

export type GetAllUsersResponse = {
  currentLimit: number;
  currentOffset: number;
  totalEntities: number;
  profiles: GetProfileByIdResponse[];
};

export type GetProfileByIdResponse = {
  profile: ResponseProfile;
  company: Company;
};

export enum CompanyRoles {
  admin = 'ADMIN',
  employee = 'EMPLOYEE'
}

export type UpdateProfileByIdRequest = Pick<
  ResponseProfile,
  | 'firstName'
  | 'lastName'
  | 'fullName'
  | 'language'
  | 'profession'
  | 'companyName'
  | 'isActive'
>;
